import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Oil.eb59699b",
  "use": "Oil.eb59699b-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"Oil.eb59699b\">\n  <path d=\"M18 2h-4v1h4V2zM12 10.996l1.432 2.392c.207.325.568 1.117.568 1.536 0 1.144-.895 2.072-2 2.072s-2-.928-2-2.072c0-.42.36-1.21.567-1.536L12 10.996z\" fill=\"currentColor\" />\n  <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7 22a1 1 0 01-1-1V8a1 1 0 01.86-.99L14 5V4h4v17a1 1 0 01-1 1H7zm9-8a4 4 0 11-8 0 4 4 0 018 0z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol